import React, { Fragment } from 'react';
// import Swiper core and required modules
import SwiperCore, { Pagination, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
require('swiper/components/pagination/pagination.min.css');

SwiperCore.use([Pagination, A11y]);

const SliderImages = ((props) => {
    return (
        !props.images || props.images.length < 1 ? <Fragment /> :
            <div className="lightbox__slider-mobile">
                <Swiper
                    pagination={{ clickable: true }}
                    spaceBetween={0}
                    slidesPerView={1}
                    loop={true}
                    speed={300}
                >
                    {props.images.map((item, index) => {
                        return (
                            <SwiperSlide key={index}>
                                <div className={'slideshow-item' + (item.iframe ? ' slideshow-item--iframe' : ' slideshow-item--photo')} >
                                    {item.iframe ? (
                                        <iframe src={item.src} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                    ) : (
                                        // <img  draggable="false" src={item.src} />
                                        <div className="slideshow-image" dangerouslySetInnerHTML={{ __html: item.src }}></div>
                                    )}
                                    {item.description &&
                                        <div className="slideshow-description">{item.description}</div>}
                                </div>
                            </SwiperSlide>
                        )
                    })}
                    <div className="swiper-pagination"></div>
                </Swiper>
            </div>
    )
})

export default SliderImages;